<template>
  <div class="open-container" :class="{'default-mode' : ($route.meta.flexMode === LayoutMode.DEFAULT), 'flex-mode' : ($route.meta.flexMode === LayoutMode.FLEX)}">
    <open-app-header v-if="!$route.meta.isArticleActive" class="open-app-header" :style="{'left': headerXScroll}" :class="{'black-background' : ($route.meta.flexMode === LayoutMode.DEFAULT || layoutDefault)}"/>
    <div class="open-app-content-container">
      <div class="open-app-content">
        <router-view></router-view>
      </div>
      <!-- <app-footer v-if="$route.meta.appFooter" class="open-app-footer"/>
      <open-app-footer v-else></open-app-footer> -->
      <app-footer v-if="!$route.meta.isArticleActive"></app-footer>
      <float-window v-if="!$route.meta.isArticleActive"></float-window>
    </div>
  </div>
</template>

<script>
import api from '@/common/api';
import ProcessEnv from '@/common/ProcessEnv';
import loader from '@/common/loader';
import store from '@/store';
import OpenAppHeader from '@/components/open/common/OpenAppHeader';
// import OpenAppFooter from '@/components/open/common/OpenAppFooter';
import AppFooter from '@/components/open/common/AppFooter';
// import AppFooter from '@/components/common/AppFooter';
import * as actionTypes from '@/store/open/action-types';
import ScrollManager from './common/ScrollManager';
import Layout from './common/Constant';
import ValidateTransferHelper from '@/components/open/common/ValidateTransferHelper';
import FloatWindow from '@/components/open/common/FloatWindow';
function transferTo(to, next) {
  if (ProcessEnv.isDebug || to.meta.needLoginAndVerifyMail !== true) {
    next();
    return;
  }
  let user = store.state.open.user;
  if (user.isLogin === true) {
    if (user.isVerifyMail === true && user.isVerifyPhone === true) {
      next();
      return;
    }
    // beforeEach之后会触发hashchange事件，导致message-box被刷新
    setTimeout(() => {
      ValidateTransferHelper.transferNext();
      // MessageBox.alert('请验证手机等，用于相关消息接受', null, MessageType.SUCCESS).then(() => {
      //   ValidateTransferHelper.transferNext();
      // });
    }, 200);
    next(false);
  } else {
    next(false);
    location.href = '/#/open';
  }
}

const IS_LOGIN_SUCCESSFUL = 1;
const IS_NEED_VERIFY_MAIL = 1;
const IS_NEED_VERIFY_PHONE = 1;

export default {
  name: 'OpenApp',
  components: {
    OpenAppHeader,
    // OpenAppFooter,
    AppFooter,
    FloatWindow
  },
  data() {
    return {
      LayoutMode: Layout.LayoutMode,
      layoutDefault: false,
      headerXScroll: 0
    };
  },
  beforeRouteEnter(to, from, next) {
    if (!store.state.open.ready) {
      loader.get(api.user.YTSTATUS, null, (error) => {
        error.stopPropagation();
        console.warn('用户未登录或者验证模块异常');
        store.dispatch(actionTypes.CLEAR_USER_INFO);
        transferTo(to, next);
      }).then((result) => {
        store.dispatch(actionTypes.SAVE_USER_INFO, {
          isLogin: result.is_login === IS_LOGIN_SUCCESSFUL,
          isVerifyMail: result.is_verify === IS_NEED_VERIFY_MAIL,
          qq: result.qq,
          userName: result.user_name,
          openid: result.openid,
          news: result.news,
          isVerifyPhone: result.is_phone_verified === IS_NEED_VERIFY_PHONE,
          token: result.token || ''
        });
        transferTo(to, next);
      });
    } else {
      transferTo(to, next);
    }
  },
  methods: {
    addheaderBgColor(param) {
      if (param.scrollTop > 10 && this.$route.meta.flexMode === this.LayoutMode.FLEX) {
        this.layoutDefault = true;
        return;
      }
      this.layoutDefault = false;
    },
    attachRouterListener() {
      let router = this.$router;
      router.beforeEach((to, from, next) => {
        if (to.path.indexOf(this.$const.route.OPEN_APP) !== 0) {
          next();
          return;
        }
        transferTo(to, next);
      });
    },
    openAppHeaderXScroll(param) {
      if (param == null) {
        return;
      }
      // header随着x轴滚动而滚动
      let scrollLeft = param.scrollLeft;
      this.headerXScroll = -scrollLeft + 'px';
    }
  },
  created() {
    document.body.addEventListener('touchstart', function() {});
    document.title = '腾讯优图AI开放平台 — 顶级的人工智能服务，多元化的行业解决方案';
    this.attachRouterListener();
  },
  mounted() {
    ScrollManager.bind(window);
    ScrollManager.register(this.addheaderBgColor);
    ScrollManager.register(this.openAppHeaderXScroll);
    window.onresize = () => {   // 屏幕尺寸变化就重新赋值
      this.headerXScroll = 0;
    };
  },
  beforeDestroy() {
    ScrollManager.degister(window);
    ScrollManager.degister(this.openAppHeaderXScroll);
    ScrollManager.unbind();
  }
};
</script>

<style lang="less" scoped>
@container-min-width: 1263px;
.open-container{
  font-family: PingFangSC-Regular,'helvetica neue','hiragino sans gb', 'microsoft yahei', tahoma,'microsoft yahei ui', simsun,sans-serif;
  min-width: @container-min-width;
  position: relative;
  @header-height: 63px;
  .black-background{
    background-color: #000000;
    box-shadow: 0px 3px 15px 3px rgba(5,3,4,0.35);
  }
  .open-app-header {
    min-width: @container-min-width;
    position: fixed;
    z-index: 3;
    top: 0;
    width: 100%;
    height: @header-height;
  }
  &.default-mode{
    height: 100%;
    .open-app-content-container {
      z-index: 1;
      position: relative;
      top: @header-height;
      min-height: calc(~'100vh - 66px');
      background-color: #f9f9f9;
      .open-app-content {
        overflow-y: auto;
      }
      .open-app-footer {
        bottom: 0;
        position: absolute;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/OpenApp.vue